import { useEffect, useState } from 'react';

export type JukeboxPopupId =
  | 'vibeSelection'
  | 'sugestaoAprovada'
  | 'sugestaoRecusada'
  | 'pedidoIniciado'
  | 'pedidoConfirmado'
  | 'toast';

export interface JukeboxPopupPendentes {
  vibeSelection:    boolean;
  sugestaoAprovada: boolean;
  sugestaoRecusada: boolean;
  pedidoIniciado:   boolean;
  pedidoConfirmado: boolean;
  toast:            boolean;
}

const ORDEM_PRIORIDADE: JukeboxPopupId[] = [
  'vibeSelection',
  'sugestaoAprovada',
  'sugestaoRecusada',
  'pedidoIniciado',
  'pedidoConfirmado',
  'toast',
];

/**
 * Garante no máximo um popup/sheet visível por vez entre os concorrentes do
 * Jukebox (pedido confirmado, pedido iniciado, sugestão aprovada, seleção de
 * vibe, toast). Cada campo em `pendentes` indica se aquele popup tem conteúdo
 * pronto para mostrar — este hook decide qual dos pendentes fica ativo,
 * respeitando ORDEM_PRIORIDADE, e só troca de ativo quando o atual deixa de
 * estar pendente (foi dispensado pelo usuário).
 */
export function useJukeboxPopupQueue(pendentes: JukeboxPopupPendentes): JukeboxPopupId | null {
  const {
    vibeSelection, sugestaoAprovada, sugestaoRecusada,
    pedidoIniciado, pedidoConfirmado, toast,
  } = pendentes;
  const [ativo, setAtivo] = useState<JukeboxPopupId | null>(null);

  useEffect(() => {
    const pendentesAtual: Record<JukeboxPopupId, boolean> = {
      vibeSelection, sugestaoAprovada, sugestaoRecusada,
      pedidoIniciado, pedidoConfirmado, toast,
    };
    if (ativo && pendentesAtual[ativo]) return;
    const proximo = ORDEM_PRIORIDADE.find(id => pendentesAtual[id]);
    setAtivo(proximo ?? null);
  }, [ativo, vibeSelection, sugestaoAprovada, sugestaoRecusada, pedidoIniciado, pedidoConfirmado, toast]);

  return ativo;
}
